import type {EditorState} from '@codemirror/state'

/** Returns true if there is actual selected text in the editor. */
export function hasNonEmptySelection(state: EditorState): boolean {
  return state.selection.ranges.length === 1 && !state.selection.main.empty
}

export function expandRangeToLineEnds(state: EditorState) {
  const caretLocation = state.selection.main.anchor
  const document = state.doc.toString()

  const lineFrom = document.slice(0, caretLocation).lastIndexOf('\n') + 1
  let lineTo = document.indexOf('\n', caretLocation)
  if (lineTo === -1) lineTo = document.length

  return {from: lineFrom, to: lineTo}
}
